module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAADCAYAAAAOVyamAAAAHElEQVQYlWP8n8nwn4HaYBp1jWSiqmk0AkPCkQAtjwQCP0uCPwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-double-color.png
// module id = 1015
// module chunks = 2